"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var StyleShortCutContainer = react_1.default.forwardRef(function (_a, ref) {
    var dark = _a.dark, lowPadding = _a.lowPadding, children = _a.children;
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)("style-shortcut", "calibre", {
            "style-shortcut--dark": dark,
        }) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("style-shortcut__content", {
                "style-shortcut__content--low-padding": lowPadding,
            }) }, children)));
});
StyleShortCutContainer.displayName = "StyleShortCutContainer";
exports.default = StyleShortCutContainer;
